import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from '#src/components/layouts/InfoLayout.tsx';

const CookiePolicy = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          defaultMessage: 'COOKIE_POLICY.md',
        })}
      />
    </InfoLayout>
  );
};

export default CookiePolicy;
